var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4 grey--text"},[_vm._v("Settings coming soon.")])
}
var staticRenderFns = []

export { render, staticRenderFns }